import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles({
    card: {
      maxWidth: 345,
      margin:10,
    },
    media: {
      height: 140,
      width: 140,
      display: "block",
      marginLeft: "auto",
      marginRight: "auto"

    },
  });
  

function NetworkCard(props) {
    const classes = useStyles();

    return (
      <Card className={classes.card}>
        <CardActionArea>
          <CardMedia
            className={classes.media}
            image={props.img}
            title="Contemplative Reptile"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              {props.network}
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
            {props.networkDescription}
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size="small" color="primary" onClick={props.onClick}>
            Setting
          </Button>
        </CardActions>
      </Card>
    );
}

export default NetworkCard;
